import { Component } from '@verndale/core';
import cookie from 'cookie-cutter';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      counter: this.el.querySelector('.header-cart__count')
    };
    this.getCookie();
  }

  addListeners() {
    window.cookieStore.onchange = this.getCookie.bind(this);
  }

  getCookie() {
    const cookieString = cookie.get('aspensnowmassCart');
    if (cookieString) {
      const pairs = cookieString.split(',');
      const splittedPairs = pairs.map(cookie => cookie.split(':'));

      const cookieObj = splittedPairs.reduce((obj, cookie) => {
        obj[decodeURIComponent(cookie[0].trim())] = decodeURIComponent(
          cookie[1].trim()
        );

        return obj;
      }, {});

      this.setCounter(cookieObj.count);
    }
  }

  setCounter(count) {
    if (!count || !this.dom.counter) return;
    this.dom.counter.innerText = count;
    this.dom.counter.removeAttribute('hidden');
  }
}

export default Module;
